import store from '@/store'

import { fetchAll } from '@/rest/freight/ports'
import { keyBy, uniq, findLastIndex } from 'lodash'
import { getPortLabels } from '@/utils/ports'

const state = {
  ports: null,
  portsMap: {},
  recentPorts: []
}

const mutations = {
  SET_PORTS: (state, ports) => {
    const sortedPorts = ports.sort(function (a, b) {
      if (a.displayName > b.displayName) {
        return 1
      }
      if (a.displayName < b.displayName) {
        return -1
      }
      return 0
    })

    // sort by city-port
    const childPorts = sortedPorts.filter(p => p.parentId)
    const portList = sortedPorts.filter(p => !p.parentId)
    portList.forEach(p => p.isChild = false)
    childPorts.forEach(p => p.isChild = true)
    childPorts.forEach(p => {
      const parentIndex = findLastIndex(portList, e => e.id === p.parentId || e.parentId === p.parentId)
      parentIndex > -1 && portList.splice(parentIndex + 1, 0, p)
    })

    // make cityPortMap
    const cityPortMap = {}
    const cities = portList.filter(p => !p.isPort)
    cities.forEach(c => cityPortMap[c.id] = portList.filter(p => p.parentId === c.id))

    state.ports = Object.freeze(portList)
    state.portsMap = Object.freeze(keyBy(state.ports, 'id'))
    state.cityPortMap = Object.freeze(cityPortMap)

    let language = store.getters.getLanguage

    state.ports.forEach(p => {
      p.labels = getPortLabels(p, language)
    })
  },
  ADD_RECENT_PORT: (state, port) => {
    const index = state.recentPorts.indexOf(port)
    if (index > -1) {
      state.recentPorts.splice(index, 1)
    }
    state.recentPorts.unshift(port)
    state.recentPorts = state.recentPorts.slice(0, 10)
  }
}

const actions = {
  /**
   * initialization on login or reload page
   *
   * @param commit
   * @param state
   * @returns {*|Promise<any>}
   */
  autoinit ({ commit, state }) {
    return actions.getPorts({ commit, state }, false)
  },

  /**
   * Get stored ports or load and store
   *
   * @param commit
   * @param state
   * @returns {Promise<any>}
   */
  getPorts ({ commit, state }, isReload) {
    return new Promise(async (resolve, reject) => {
      if (state.ports == null || isReload) {
        const ports = await fetchAll()
        commit('SET_PORTS', ports)
      }
      resolve(state.ports)
    })
  },

  addRecentPort (context, port) {
    context.commit('ADD_RECENT_PORT', port)
  },

  reloadPorts ({ commit, state }) {
    return actions.getPorts({ commit, state }, true)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/ports.js